<template>
  <div>
  <b-button @click="toggle()" variant="success"><i class="nav-icon fa fa-car"></i> Boton Autos</b-button>
  <b-modal v-model="visible" title="Editar Permisos por Usuario">
    <b-row>
        <b-col>
            <b-table
                :items="data"
                :fields="cols"
                :current-page="currentPage"
                :per-page="perPage"
            >
                <template #cell(cod_agente)="data">
                  <input type="checkbox" :name="'elimCod'+data.item.id" v-model="eliminables" :value="data.item.cod_agente"/>                  
                  <label class="ml-3" :for="'elimCod'+data.item.id">{{data.item.cod_agente}}</label>
                </template>
                <template #cell(agente_name)="data">
                  <span :class="data.item.agente_name?'text-dark':'text-secondary'">{{ data.item.agente_name?data.value:'Agente aun no registrado' }}</span>
                </template>
            </b-table>
            <b-card-footer class="px-3 py-2">
            <b-row align-v="center">
              <b-col>{{ registros  }} de {{ data.length }} resultados</b-col>
              <b-col>
                <b-pagination size="sm" :total-rows="data.length" :per-page="perPage" prev-text="Anterior" v-model="currentPage" next-text="Siguiente" @change="setCurrentPage"/>
              </b-col>
              <b-col></b-col>
            </b-row>
          </b-card-footer>
        </b-col>
    </b-row>
    <template v-slot:modal-footer>
      <div class="w-100">
        <b-button variant="danger" class="mr-2" @click="eliminar" :disabled="!eliminables.length || deleting">
          <i class="fa fa-minus" v-if="!deleting"></i>
          <i class="fa fa-spinner fa-spin" v-else></i>
          Eliminar Seleccionados
        </b-button>

        <b-button variant="primary" class="float-right" @click="submit" :disabled="sending">
          <i class="fa fa-plus" v-if="!sending"></i>
          <i class="fa fa-spinner fa-spin" v-else></i>
          Nuevo
        </b-button>
      </div>
    </template>
  </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      sending: false,
      deleting: false,      
      cols: [{key: 'cod_agente', label: 'Codigo de Agente'},
             {key: 'agente_name', label: 'Agente'}],
      perPage: 5,
      currentPage: 1,
      data: [],      
      eliminables: [],
      payload: {
        cod_agente: [],
        tipo_permiso: ''
      }
    }
  },
  computed:{
    registros(){      
      return (this.perPage * this.currentPage < this.data.length)?(this.perPage * this.currentPage):this.data.length;
    }
  },
  methods: {
    setCurrentPage(n){
        this.currentPage = n;
    },
    toggle: async function() {      
      if(!this.visible){
        let loading = this.$loading.show();
        await this.$api('permisos/boton%20autos')
                  .then(r => {
                        this.data = r.data.map(x => {x.agente_name = x.agente?x.agente.name:null; return x});
                        loading.hide();
                   });

        this.visible = !this.visible;
      }
    },
    submit: async function () {            
      this.payload.cod_agente = prompt('Ingrese el o los codigos de agentes autorizados separados por una coma (,): ', this.payload.cod_agente?this.payload.cod_agente.toString():'');
      this.payload.tipo_permiso = 'boton autos';
      if (this.payload.cod_agente == null){        
        return;
      }

      if (this.payload.cod_agente == ''){
        this.$toast.error('Ingrese al menos un codigo de agente.');
        return;
      }
      
      this.payload.cod_agente = this.payload.cod_agente.split(',');
      let noNumericos = this.payload.cod_agente.filter(x => isNaN(parseInt(x)));
      if (noNumericos.length){
        this.$toast.error('Uno o varios de los codigos ingresados no son validos ('+noNumericos.toString()+'). Ingrese solo codigos numericos');
        return;
      }
      
      let repetidos = this.payload.cod_agente.map(x => this.data.some(y => y.cod_agente==x)?x:null).filter(z => z != null);      
      if (repetidos.length){
        this.$toast.error('Uno o varios de los codigos ingresados ya existen en el listado ('+repetidos.toString()+'). Ingrese solo nuevos codigos');
        return;
      }
      this.sending = true;      
      this.$api.post('permisos/create', this.payload)
               .then(r => {
                    this.data = this.data.concat(r.data.map(x => {x.agente_name = x.agente?x.agente.name:null; return x}));
                    this.sending = false;
                    this.payload.cod_agente = [];
                    this.$toast.success('Listado actualizado satisfactoriamente.');
               });
    },
    eliminar: async function(){
      this.payload.cod_agente = this.eliminables;
      this.payload.tipo_permiso = 'boton autos';
      this.deleting = true;
      this.$api.post('permisos/destroy', this.payload)
               .then(r => {
                  this.data = r.data.map(x => {x.agente_name = x.agente?x.agente.name:null; return x});
                  this.deleting = false;
                  this.payload.cod_agente = [];
                  this.eliminables = [];
                });
    }
  },
};
</script>
    